import { ApiMap } from '../ApiMap';
const PathsResponseCache = {};
const asPathsCacheKey = dataTokenConfig => {
  const {
    dataTokenContext,
    supportedCrmObjectFQNs = [],
    hideSiteSettingsCategory,
    includeInternalContactRecord,
    includeSubscriptionTypeCategory,
    hideFallbacks,
    isEmail,
    unsupportedDataTokenPaths
  } = dataTokenConfig;
  return JSON.stringify([dataTokenContext, supportedCrmObjectFQNs, hideSiteSettingsCategory, includeInternalContactRecord, includeSubscriptionTypeCategory, hideFallbacks, isEmail, unsupportedDataTokenPaths]);
};

/**
 *
 * @param unsupportedDataTokenPaths Array of exact token paths or REGEX patterns
 */
export const filterUnsupportedDataTokenPaths = (unsupportedDataTokenPaths = [], dataTokenNodes) => {
  if (unsupportedDataTokenPaths.length > 0) {
    const unsupportedPathRegexes = unsupportedDataTokenPaths.map(path => new RegExp(path));
    return dataTokenNodes.reduce((acc, node) => {
      const updatedNode = Object.assign({}, node);
      if (node.childNodes) {
        updatedNode.childNodes = filterUnsupportedDataTokenPaths(unsupportedDataTokenPaths, node.childNodes);
      }
      let shouldFilter = false;
      unsupportedPathRegexes.forEach(regex => {
        shouldFilter = shouldFilter || regex.test(node.path || '');
      });
      if (!shouldFilter) {
        acc.push(updatedNode);
      }
      return acc;
    }, []);
  }
  return dataTokenNodes;
};
export function getFetchPaths(http, dataTokenConfig) {
  return () => {
    const cacheKey = asPathsCacheKey(dataTokenConfig);
    if (Object.prototype.hasOwnProperty.call(PathsResponseCache, cacheKey)) {
      return PathsResponseCache[cacheKey];
    }
    const {
      dataTokenContext,
      hideFallbacks,
      hideSiteSettingsCategory,
      includeInternalContactRecord,
      includeSubscriptionTypeCategory,
      includeUserObjectProperties,
      isEmail,
      supportedCrmObjectFQNs,
      unsupportedDataTokenPaths,
      useDefaultLabelForCrmObjectTypes = false
    } = dataTokenConfig;
    const requestConfig = {
      includeInternalContactRecord
    };
    let fieldDefaultValueSource;
    if (hideFallbacks) {
      fieldDefaultValueSource = 'NONE';
    } else if (isEmail) {
      fieldDefaultValueSource = 'EMAIL';
    } else {
      fieldDefaultValueSource = 'PAGE';
    }
    if (dataTokenContext) {
      requestConfig.dataTokenContext = dataTokenContext;
    }
    if (supportedCrmObjectFQNs && supportedCrmObjectFQNs.length > 0) {
      requestConfig.dataTokenSources = {
        crmObjectTypeFQNs: supportedCrmObjectFQNs,
        deliverOfficeSettings: !hideSiteSettingsCategory,
        deliverSubscriptionType: includeSubscriptionTypeCategory,
        fieldDefaultValueSource,
        useDefaultLabelForCrmObjectTypes
        // unsupportedDataTokenPaths, // @TODO: Filter through the API instead?
      };
    }
    if (includeUserObjectProperties) {
      requestConfig.includeUserObjectProperties = includeUserObjectProperties;
    }
    PathsResponseCache[cacheKey] = http.post(ApiMap.PATHS.getUrl(), {
      data: requestConfig
    }).then(dataResponse => {
      const {
        dataTokenNodes
      } = dataResponse;
      return {
        dataTokenNodes: filterUnsupportedDataTokenPaths(unsupportedDataTokenPaths, dataTokenNodes)
      };
    });
    return PathsResponseCache[cacheKey];
  };
}